import { AttachmentFileType } from '../types/AttachmentFile';
import { getExtensionFromFileName } from 'owa-file-common';
export default function createUriFiles(entries) {
    var uriList = entries.map(function (entry) {
        return {
            fileType: AttachmentFileType.Uri,
            name: entry.name,
            type: getExtensionFromFileName(entry.url),
            size: 0,
            uri: entry.url,
        };
    });
    return uriList;
}
//# sourceMappingURL=createUriFiles.js.map